import { Directive } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

/**
 * Abstract class to be extended by custom form components that require a selector.
 *
 * It implements all methods of the ControlValueAccessor interface and provides the necessary
 */
@Directive()
export abstract class SelectorField<T> implements ControlValueAccessor {
  selectedValue: T | null = null; // The selected value of the field
  touched = false; // Track if the field has been touched

  onModelChange: (fieldValue: T) => void = () => {
    // onModelChange triggered but not registered.
  };

  onTouched: () => void = () => {
    //  onTouched triggered but not registered.
  };

  registerOnChange(onModelChange: (selectedValue: T) => void): void {
    this.onModelChange = onModelChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  writeValue(selectedValue: T): void {
    this.selectedValue = selectedValue;
  }

  onSelectValue(selectedValue: T) {
    this.onModelChange(selectedValue);
    this.writeValue(selectedValue);
  }

  /**  Ensure`onTouched()` is only called once per interaction */
  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
